if (!customElements.get("recently-viewed-products")) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();
      this.grid = null;
    }

    connectedCallback() {
      this.grid = this.querySelector("[data-search-history-grid]");
      if (!this.grid) return;
      this.load();
      document.addEventListener("search:open", () => this.load());
    }

    async load() {
      const limit =
        Number.parseInt(this.dataset.searchHistoryLimit || "10", 10) || 10;
      const apiEndpoint = this.dataset.searchHistoryUrl || "";
      const sectionId = this.dataset.searchHistorySection || "";
      if (!apiEndpoint || !sectionId) {
        this.classList.add("hidden");
        return;
      }

      const storageKey = "product_history_ids";
      let entries = [];
      try {
        const raw = localStorage.getItem(storageKey);
        const parsed = raw ? JSON.parse(raw) : [];
        entries = Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        entries = [];
      }
      const ids = entries.map(String).filter(Boolean);
      const seen = new Set();
      const selected = ids
        .filter((id) => {
          if (seen.has(id)) return false;
          seen.add(id);
          return true;
        })
        .slice(0, limit);
      if (!selected.length) {
        this.classList.add("hidden");
        return;
      }

      const searchQuery = selected.map((id) => `id:${id}`).join(" OR ");
      const queryParams = new URLSearchParams({
        q: searchQuery,
        type: "product",
        section_id: sectionId,
        ose: "false",
      });
      const url = `${apiEndpoint}?${queryParams.toString()}`;
      const fetchHtml = window.webvista?.fetchHtml;
      if (!fetchHtml) {
        this.classList.add("hidden");
        return;
      }
      try {
        const doc = await fetchHtml(url);
        const items = doc.querySelector("[data-search-history-items]");
        if (!items || !items.innerHTML.trim()) {
          this.classList.add("hidden");
          return;
        }
        this.grid.innerHTML = items.innerHTML;
        this.classList.remove("hidden");
        if (window.webvista?.initLazyImageAnimation) {
          window.webvista.initLazyImageAnimation(this.grid);
        }
      } catch (error) {
        this.classList.add("hidden");
      }
    }
  }

  customElements.define("recently-viewed-products", RecentlyViewedProducts);
}
